/**
 * Returns the whole number rounded percentage complete between 0 and 100
 * for a package or task state.
 * @param state - a package or task state with a 'progress' map attribute.
 */
export function getProgressPercentComplete(state) {
    const size = state.get('size');
    if (size === 0) {
        return 0;
    }
    return state ? Math.round((100 * state.getIn(['progress', 'C'], 0)) / size) : 0;
}

/**
 * Returns the number of task items completed in a package or task
 * @param state - a package or task state with a 'progress' map attribute.
 */
export function getTaskItemsComplete(state) {
    const size = state.get('size');
    if (size === 0) {
        return 0;
    }
    return state ? state.getIn(['progress', 'C'], 0) : 0;
}

/**
 * Returns if a package or task has been started.
 * @param state - a package or task state with a 'progress' map attribute.
 * @returns boolean - if the task or package has been started or not.
 */
export function isProgressStarted(state) {
    return state && state.get('progress', []).reduce((p, v) => p + v, 0) > 0;
}
